import { ChatMessageData } from "@virtualprogaming/js-public-sdk";
import { useQuery, UseQueryOptions } from "react-query";

import { useChatApi } from "./useChatApi";

export function useChatConversationMessages(
  accessToken: string,
  id: number,
  top: number,
  options?: UseQueryOptions<ChatMessageData>
) {
  const api = useChatApi();
  return useQuery({
    queryKey: ["chat-conversation-messages", id, accessToken, top],
    queryFn: async () => {
      const { data } = await api.getConversationMessages(
        id,
        accessToken,
        "id desc",
        top
      );
      return data;
    },
    ...options,
    refetchInterval: 5000,
  });
}
